import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";

type RecipeProps = {
  title: string;
  image: string;
  recipeDescription: string;
  steps: string;
};

export default function Recipe(props: RecipeProps) {
  const { title, image } = props;

  return (
    <Card sx={{ height: "100%" }}>
      <CardHeader title={title} />
      <CardMedia
        component="img"
        sx={{ height: "80%" }}
        image={image}
        alt="Paella dish"
      />
    </Card>
  );
}
